import { render, staticRenderFns } from "./PageSubTitleText.vue?vue&type=template&id=5dae0966&"
import script from "./PageSubTitleText.vue?vue&type=script&lang=js&"
export * from "./PageSubTitleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports